"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.localeSort = exports.Language = exports.isChineseChar = exports.isChinese = void 0;
const pinyin_pro_1 = require("pinyin-pro");
const isChinese = (language) => language.includes('zh');
exports.isChinese = isChinese;
const isChineseChar = (char) => /\p{Script=Han}/u.test(char);
exports.isChineseChar = isChineseChar;
var Language;
(function (Language) {
    Language["English"] = "en";
    Language["Chinese"] = "zh";
    Language["Spanish"] = "es";
    Language["German"] = "de";
    Language["French"] = "fr";
})(Language || (exports.Language = Language = {}));
function localeSort(values, { language, desc, getProperty }) {
    const result = [...values];
    if (language === Language.Chinese) {
        result.sort((v1, v2) => {
            const prop1 = getProperty(v1);
            const prop2 = getProperty(v2);
            const isName1Chinese = (0, exports.isChineseChar)(prop1.charAt(0));
            const isName2Chinese = (0, exports.isChineseChar)(prop2.charAt(0));
            //E3D4M-8755 it is exception for values start with ‘阿', it should be sorted as 'a', but this rule is not implemented in pinyin yet.
            if (prop1.charAt(0) === '阿' && prop2.charAt(0) !== '阿') {
                return desc ? 1 : -1;
            }
            if (prop2.charAt(0) === '阿' && prop1.charAt(0) !== '阿') {
                return desc ? -1 : 1;
            }
            if (isName1Chinese && isName2Chinese) {
                const pinyin1 = (0, pinyin_pro_1.pinyin)(prop1, {
                    toneType: 'none',
                });
                const pinyin2 = (0, pinyin_pro_1.pinyin)(prop2, {
                    toneType: 'none',
                });
                return desc
                    ? pinyin2.localeCompare(pinyin1)
                    : pinyin1.localeCompare(pinyin2);
            }
            if (!isName1Chinese && isName2Chinese) {
                return desc ? -1 : 1;
            }
            if (!isName2Chinese && isName1Chinese) {
                return desc ? 1 : -1;
            }
            return desc ? prop2.localeCompare(prop1) : prop1.localeCompare(prop2);
        });
    }
    else {
        result.sort((v1, v2) => {
            const prop1 = getProperty(v1);
            const prop2 = getProperty(v2);
            return desc ? prop2.localeCompare(prop1) : prop1.localeCompare(prop2);
        });
    }
    return result;
}
exports.localeSort = localeSort;
